import { initMap, equalCols } from '../functions';
import Swal from 'sweetalert2'

$.fn.isInViewport = function() {
	var elementTop = $(this).offset().top;
	var elementBottom = elementTop + $(this).outerHeight();

	var viewportTop = $(window).scrollTop();
	var viewportBottom = viewportTop + $(window).height();

	return elementBottom > viewportTop && elementTop < viewportBottom;
};

$(document).ready(function() {

	$('.select2').select2();

	$('.date-picker').datepicker({
        autoclose: true
    });

	/* A jQuery function that is toggling the class active on the element with the class submenu-btn. */
	$(".submenu-btn").on('click', function(e) {
		e.preventDefault();
		$(this).toggleClass('active');
		$(this).siblings('.drop-list').slideToggle();
	});
	$(".has-submenu").on('click', function(e) {
		e.preventDefault();
		$(this).parent().find('.submenu-btn').toggleClass('active');
		$(this).parent().find('.submenu-btn').siblings('.drop-list').slideToggle();
	});

	/* This is a jQuery function that is adding the class active to the header element when the user
	scrolls down more than 50px. */
	$(window).scroll(function(){
		if ($(this).scrollTop() > 50) {
		   $('header').addClass('active');
		} else {
		   $('header').removeClass('active');
		}
	});

	/* Adding the class active to the parent element of the element with the class active. */
	$(".drop-list ul").each(function (index, element) {
		let elements = $(element).children('li').children();
		let activeParent = $(this).parent('.drop-list').siblings('.has-submenu');

		if(elements.hasClass("active")) {
			activeParent.addClass('active');
		}
	});

	if ($(".twentytwenty-container").length > 0)
	{
		$(".twentytwenty-container").twentytwenty();
	}


	$(document).on('click', '.boxes-category-btn', function(e) {
		e.preventDefault();
		var moduleId = $(this).data('module');
		var categoryId = $(this).data('id');

		$(this).parent().siblings().removeClass('swiper-slide-active');
		$(this).parent().addClass('swiper-slide-active');

		if (categoryId == 0) {
			$('.boxes-' + moduleId).show();
			return;
		}

		$('.boxes-' + moduleId).hide();
		$('.box-' + moduleId + '-' + categoryId).show();
	});
});



// WEBPACK FOOTER //
// ./resources/assets/js/regular/general.js